import { ChevronsUp, Minus, ChevronDown } from "lucide-react";

const MAP = {
  Alta: { cls: "bg-danger/10 text-danger border-danger/25", Icon: ChevronsUp },
  Media: { cls: "bg-warning/10 text-warning border-warning/25", Icon: Minus },
  Bassa: { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: ChevronDown },
};

/** Indicatore di priorità: colore + testo + icona. */
export function PriorityBadge({ level = "Media", className = "", testid }) {
  const conf = MAP[level] || MAP.Media;
  const Icon = conf.Icon;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-semibold ${conf.cls} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" /> {level}
    </span>
  );
}
